import React from "react";
import { motion } from "framer-motion";

const HormonalCycleGraph: React.FC = () => {
    return (
        <div className="space-y-3" dir="rtl">
            <div>
                <h4 className="font-medium text-[#002B5C] mb-1">وضعیت چرخه</h4>
                <div className="grid grid-cols-2 gap-3 mb-3">
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#A7FFEB]">۱۴</div>
                        <div className="text-xs text-[#9EA3A9]">روز چرخه</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#A7FFEB]">۱۴</div>
                        <div className="text-xs text-[#9EA3A9]">روز تا چرخه بعدی</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#A7FFEB]">۳۶.۸°C</div>
                        <div className="text-xs text-[#9EA3A9]">دمای بدن (↑)</div>
                    </div>
                    <div className="bg-[#ECEFF1] p-3 rounded-[16px] text-center shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                        <div className="text-lg font-medium text-[#32D74B]">پایدار</div>
                        <div className="text-xs text-[#9EA3A9]">وضعیت خلق</div>
                    </div>
                </div>

                <h4 className="font-medium text-[#002B5C] mb-1">نمودار چرخه</h4>
                <div className="h-20 bg-[#ECEFF1] rounded-[16px] p-3 relative shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    <div className="absolute inset-0 flex items-center">
                        <div className="w-full h-0.5 bg-[#9EA3A9]/20"></div>
                    </div>
                    <div className="relative h-full flex">
                        <div className="w-1/4 h-full flex flex-col justify-end">
                            <motion.div
                                className="w-full bg-[#FF4F00]/50 rounded-l-sm"
                                initial={{ height: 0 }}
                                animate={{ height: "40%" }}
                                transition={{
                                    duration: 0.2,
                                    ease: [0.4, 0.0, 0.2, 1],
                                }}
                            />
                            <span className="text-[10px] text-[#9EA3A9] mt-1 text-center">قاعدگی</span>
                        </div>
                        <div className="w-1/4 h-full flex flex-col justify-end">
                            <motion.div
                                className="w-full bg-[#FFD60A]/50"
                                initial={{ height: 0 }}
                                animate={{ height: "60%" }}
                                transition={{
                                    duration: 0.2,
                                    delay: 0.1,
                                    ease: [0.4, 0.0, 0.2, 1],
                                }}
                            />
                            <span className="text-[10px] text-[#9EA3A9] mt-1 text-center">فولیکولار</span>
                        </div>
                        <div className="w-1/4 h-full flex flex-col justify-end relative">
                            <motion.div
                                className="w-full bg-[#A7FFEB]/70"
                                initial={{ height: 0 }}
                                animate={{ height: "80%" }}
                                transition={{
                                    duration: 0.2,
                                    delay: 0.2,
                                    ease: [0.4, 0.0, 0.2, 1],
                                }}
                            />
                            <span className="text-[10px] text-[#9EA3A9] mt-1 text-center">تخمک‌گذاری</span>
                            <div className="absolute bottom-[80%] left-1/2 transform -translate-x-1/2 w-3 h-3 bg-[#A7FFEB] rounded-full border-2 border-white"></div>
                        </div>
                        <div className="w-1/4 h-full flex flex-col justify-end">
                            <motion.div
                                className="w-full bg-[#0072CE]/50 rounded-r-sm"
                                initial={{ height: 0 }}
                                animate={{ height: "70%" }}
                                transition={{
                                    duration: 0.2,
                                    delay: 0.3,
                                    ease: [0.4, 0.0, 0.2, 1],
                                }}
                            />
                            <span className="text-[10px] text-[#9EA3A9] mt-1 text-center">لوتئال</span>
                        </div>
                    </div>
                </div>

                <div className="mt-4 p-3 bg-[#ECEFF1] rounded-[16px] shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
                    <h4 className="font-medium text-[#002B5C] mb-1">تحلیل و توصیه‌ها</h4>
                    <p className="text-sm text-[#4A5568]">
                        شما در فاز تخمک‌گذاری چرخه هستید. افزایش دمای بدن و تغییرات ضربان قلب تأیید کننده این مرحله است. برای حفظ تعادل هورمونی، خواب منظم و کاهش استرس توصیه می‌شود.
                    </p>
                    <div className="mt-2 text-xs text-[#9EA3A9]">تحلیل بر اساس الگوی خواب، دما و تغییرات ضربان قلب</div>
                </div>
            </div>
        </div>
    );
};

export default HormonalCycleGraph;
